import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-173dfdf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "air-forecast" }
const _hoisted_2 = { class: "air-forecast-container" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-icon" }, null, -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "week" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_9 = ["xlink:href"]
const _hoisted_10 = { class: "weather" }
const _hoisted_11 = { class: "temperature" }
const _hoisted_12 = { class: "wind-direction" }
const _hoisted_13 = { class: "wind-strength" }

import {
  computed, watch, onMounted, ref,
} from 'vue';
import { useStore, } from 'vuex';
import qs from 'qs';
import moment from 'moment';
import 'moment/locale/zh-cn';

import {
  factorColorRender,
  factorEmoRender,
  fontColorRender,
  weatherRender,
  factorTxtRender,
} from '@/utils/index';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const now = computed(() => {
  const temp = moment().hour();

  if (temp < 12) {
    return 'windDirectionAm';
  }

  return 'windDirectionPm';
});

const dateFormate = 'MM月DD日';
const dayFormate = 'ddd';

const store = useStore();

const regionId = computed<number>(() => store.state.OLMap.regionId) || 320100000000;
const location = computed(() => store.state.OLMap.location.location.city);

const selectRegionName = computed(() => store.state.airStatus.selectRegionName);

// 面包屑选中城市id
const selectCityId = computed(() => store.state.airStatus.selectCityId);

const pointInfo = computed(() => store.state.airStatus.pointInfo);

const regionName = ref('');

watch(pointInfo, (curInfo) => {
  if (curInfo.pointName) {
    regionName.value = curInfo.pointName;
  }
});

watch(selectRegionName, (curName) => {
  if (curName) {
    regionName.value = curName;
  }
});

/**
 * 加载空气质量预报
 * @return {void}
 */
const getWeatherForecast = () => {
  const params = qs.stringify({
    regionId: regionId.value,
  });

  store.dispatch('gateway/loadWeatherList', params);
};

watch(selectCityId, (curid) => {
  if (curid) {
    const params = qs.stringify({
      regionId: curid,
    });

    store.dispatch('gateway/loadWeatherList', params);
  }
});

watch(regionId, (cur) => {
  if (cur) {
    getWeatherForecast();
  }
});

onMounted(() => {
  if (regionId.value) {
    getWeatherForecast();
  }
});

/**
 * @todo 历史数据不确定几条
 */
const weatherList = computed(() => {
  // const lastDays:any[] = [];
  const nextDays:any[] = [];

  /*
   * store.state.gateway.weatherList.slice(0, 3).forEach((item:any) => {
   *   lastDays.push({ ...item, key: 'lastDay', });
   * });
   */

  const today = { ...store.state.gateway.weatherList[0],key: 'today', };

  store.state.gateway.weatherList.slice(1,5).forEach((item:any) => {
    nextDays.push({ ...item, key: 'nextDay', });
  });

  return [
    today, ...nextDays,
  ];
});

/**
 * 天气和风速处理
 * @param {any} val 处理对象
 * @param {string}am 上午
 * @param {string} pm 夜里
 * @return {string} 处理返回值
 */
const weather = (val: any, am: string,pm:string):string => `${val[am]}${val[am] === val[pm] ?
  '' :
  `转${val[pm]}`}`;

const windDirection = (val:string) => {
  switch (val) {
  case '北风':
    return 'north';
  case '东北风':
    return 'noth-east';
  case '西北风':
    return 'north-west';
  case '南风':
    return 'south';
  case '东南风':
    return 'south-east';
  case '西南风':
    return 'south-west';
  case '东风':
    return 'east';
  case '西风':
    return 'west';
  default:
    return 'north';
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(regionName.value ? regionName.value : _unref(location)) + "空气质量指数（AQI）预报 ", 1)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weatherList), (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.key,
            class: _normalizeClass(item.key === 'lastDay' ? 'lastDay' : '')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["dot", item.key === 'today' ? 'today' : '' ])
            }, null, 2),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(moment)(item.weatherDate).format(dayFormate)), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(moment)(item.weatherDate).format(dateFormate)), 1),
            _createElementVNode("div", {
              class: "aqi",
              style: _normalizeStyle({
              backgroundColor: item.aqi? _unref(factorColorRender)(Number(item.aqi), 'aqi') : _unref(factorColorRender)(-9999, 'aqi'),
              color: item.aqi? _unref(fontColorRender)(Number(item.aqi), 'aqi') : _unref(fontColorRender)(-9999, 'aqi')
            })
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["iconfont", `icon-emo-${item.aqi ? _unref(factorEmoRender)(Number(item.aqi), 'aqi') : _unref(factorEmoRender)(-9999, 'aqi')}`])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(item.aqi) + "    AQI   " + _toDisplayString(_unref(factorTxtRender)(Number(item.aqi), 'aqi')), 1)
            ], 4),
            (_openBlock(), _createElementBlock("svg", _hoisted_8, [
              _createElementVNode("use", {
                "xlink:href": `#icon-${Number(_unref(moment)().format('hh')) < 12 ? _unref(weatherRender)(item.weatherAm) : _unref(weatherRender)(item.weatherPm)}`
              }, null, 8, _hoisted_9)
            ])),
            _createElementVNode("div", _hoisted_10, _toDisplayString(weather(item,'weatherAm','weatherPm')), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.temperaturePm) + "℃- " + _toDisplayString(item.temperatureAm) + "℃", 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(weather(item,'windDirectionAm','windDirectionPm')), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(weather(item,'windStrengthAm','windStrengthPm')), 1)
          ], 2))
        }), 128))
      ])
    ])
  ]))
}
}

})